import React, { useState, useEffect, useContext, createContext } from 'react';

export const SidebarContext = createContext();

export function SidebarProvider({ children, defaultItem }) {
    const [currentItem, setCurrentItem] = useState(defaultItem);
    // MYID-H9 (2026-05-26) — mobile drawer open/close lifted to context
    // so the hamburger button + overlay + nav items all share state
    // without prop-drilling. Auto-closes on route change so the drawer
    // never lingers on top of the destination page.
    const [isMobileOpen, setIsMobileOpen] = useState(false);

    useEffect(() => {
        if (defaultItem !== currentItem) {
            return setCurrentItem(defaultItem);
        }
    }, [currentItem, defaultItem]);

    useEffect(() => {
        if (isMobileOpen) setIsMobileOpen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultItem]);

    return (
        <SidebarContext.Provider
            value={{ currentItem, setCurrentItem, isMobileOpen, setIsMobileOpen }}
        >
            {children}
        </SidebarContext.Provider>
    );
}

/** MYID-H9 — convenience for components that only touch drawer state. */
export function useMobileDrawer() {
    const { isMobileOpen, setIsMobileOpen } = useContext(SidebarContext);
    return { isMobileOpen, setIsMobileOpen };
}

export const useSidebar = ({ isCollapsible, item, items = [] } = {}) => {
    const { currentItem, setCurrentItem } = useContext(SidebarContext);
    const isActive = item === currentItem || items.includes(currentItem);
    const [isExpanded, setIsExpanded] = useState(isActive);

    useEffect(() => {
        if (!isActive && isExpanded) {
            return setIsExpanded(false);
        }
        if (isActive && !isExpanded) {
            return setIsExpanded(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentItem]);

    const onItemClick = () => {
        if (!isCollapsible) {
            setCurrentItem(item);
        }
        setIsExpanded((prev) => !prev);
    };

    return {
        isExpanded,
        isActive,
        onItemClick
    };
};
